export class MemberData {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly gender?: string;
  readonly dob?: string;
  readonly tenantId?: string;

  constructor(init?: Partial<MemberData>) {
    Object.assign(this, init);
  }
}
